import styles from "./requestBody.module.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { useMemo } from "react";
import { getRequestHeaders } from "../../../utils/testCaseUtils";
import { findProjectSettings } from "../../../store/selectors";

export const RequestBody = () => {
  const { t } = useTranslation();

  const selectedVariables = useSelector((state: RootState) => state.mainSlice.selectedVariables);
  const selectedTestCase = useSelector((state: RootState) => state.testCaseTemplateSlice.selectedTestCase);
  const selectedEnvironment = useSelector((state: RootState) => findProjectSettings(state).selectedEnvironment);

  const requestHeaders = useMemo(() => {
    return getRequestHeaders(selectedVariables, selectedTestCase, selectedEnvironment.defaultHeaders);
  }, [selectedEnvironment, selectedTestCase, selectedVariables]);

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {`${t("common.body")} / ${t("common.parametersString")}`}
      </div>
      <div className={styles.bodyContainer}>
        <div className={styles.body}>
          {!!selectedTestCase.body && (
            <pre className={styles.json}>{selectedTestCase.body}</pre>
          )}
          {!selectedTestCase.body && !!selectedTestCase.payload && (
            <pre className={styles.json}>{selectedTestCase.payload}</pre>
          )}
        </div>
        <div className={styles.headers}>
          <div className={styles.title}>
            {t("common.requestHeaders")}
          </div>
          <div className={styles.body}>
            {requestHeaders.map(header => (
                <div className={styles.info} key={header.name}>
                  <div className={styles.name}>{ header.name }:</div>
                  <div className={styles.value}>{ header.value }</div>
                </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}